import dayjs, { Dayjs } from "dayjs";
import DatePicker, { DatePickerProps } from "../date-picker";
import { useDataEntryRestriction } from "@/shared/security/model/data-entry-restriction";

export type OffsetDateProps = Omit<DatePickerProps, "onChange"> & {
  onChange?: (date: string | null) => void;
};

/**
 * При очистке поля (крестик allowClear) пикер отдаёт в onChange null, хотя тип
 * antd этого не отражает, — поэтому пустое значение обрабатываем явно и
 * пробрасываем наверх как null (форма/фильтр трактуют его как «не задано»).
 */
export function normalize(value: Dayjs | null | undefined) {
  return value ? value.format("YYYY-MM-DD") : null;
}

export function OffsetDate({ disabled, ...props }: OffsetDateProps) {
  const { value, onChange } = props;

  const { canModify } = useDataEntryRestriction();

  return (
    <DatePicker
      {...props}
      value={value ? dayjs(value) : undefined}
      onChange={(date) => {
        onChange?.(normalize(date));
      }}
      disabled={!canModify || disabled}
    />
  );
}
